module.exports = __webpack_public_path__ + "img/955-e6fca8.png";